


const axios = require("axios");
const axiosInstance = require(".").default;

const responseBody = (response) => response.data;
const errorBody = (error) => error.response?.data;

const ApiRequest = {
  get: (url) => axiosInstance.get(url).then(responseBody).catch(errorBody),
  post: (url, body) => axiosInstance.post(url, body).then(responseBody).catch(errorBody)
};

module.exports = ApiRequest;
